import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class UserService {
    // Get officers with filters and pagination
    static async getOfficers(params = {}) {
        const response = await axiosInstance.get(
            API_PATHS.getofficers,
            { params }
        );

        return response.data;
    }

    // Create single officer
    static async createOfficer(payload) {
        const response = await axiosInstance.post(
            API_PATHS.createofficer,
            payload
        );

        return response.data;
    }

    // Bulk create officers
    static async bulkCreateOfficer(payload) {
        const response = await axiosInstance.post(
            API_PATHS.bulkcreateofficer,
            payload
        );

        return response.data;
    }

    // Update officer
    static async updateOfficer(id, payload) {
        const url = API_PATHS.updateofficer.replace(":id", id);

        const response = await axiosInstance.put(url, payload);

        return response.data;
    }

    // Delete officer
    static async deleteOfficer(id) {
        const url = API_PATHS.deleteofficer.replace(":id", id);

        const response = await axiosInstance.delete(url);

        return response.data;
    }

    // Synchronize officer assignments
    static async syncOfficerAssignments(payload = {}) {
        const response = await axiosInstance.post(
            API_PATHS.syncofficerassignments,
            payload
        );

        return response.data;
    }
}

export default UserService;
